import {Component, Inject} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule,} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';

@Component({
    selector: 'frog-access-token-complete',
    imports: [
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    templateUrl: './access-token-complete.component.html',
    styleUrl: './access-token-complete.component.scss',
})
export class AccessTokenCompleteComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: string) {}

    copyToken() {
        navigator.clipboard.writeText(this.data);
    }
}
